import React, { FC } from 'react';
import Modal, { ModalTransition, Appearance, ModalHeader, ModalTitle, ModalBody } from '@atlaskit/modal-dialog';
import './confirmation-dialog.scss';

interface RequestModalProps {
  modalContent: React.ReactNode;
  isOpen: boolean;
  modalTitle?: React.ReactNode;
  appearance?: Appearance;
}

const ConfirmationDialog: FC<RequestModalProps> = ({ modalContent, isOpen, modalTitle, appearance }) => {
  return (
    <>
      <ModalTransition>
        {isOpen && (
          <Modal testId="confirmation-dialog-content">
            {modalTitle ? (
              <ModalHeader>
                <ModalTitle appearance={appearance}>{modalTitle}</ModalTitle>
              </ModalHeader>
            ) : null}
            <ModalBody>
              <div className="dialog-modal-body">{modalContent}</div>
            </ModalBody>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default ConfirmationDialog;
